/**
 * Implements a functional singleton interface, mostly useful to allow
 * testing of singletons if needed.
 *
 * @param fn A function returning an instance
 */
export function singleton<T>(fn: () => T): Singleton<T> {
	let instance: T;
	return {
		getInstance() {
			if (instance) {
				return instance;
			}
			instance = fn();
			return instance;
		},
	};
}

export interface Singleton<T> {
	getInstance(): T;
}
